import CustomChip from "components/common/Chip";

import "components/Screens/Marketplace/Customer/ProfileSection/ProfileContent.scss";

interface HandsOnExperienceSectionProps {
  experience: string[];
}

function HandsOnExperienceSection({ experience }: HandsOnExperienceSectionProps) {
  return (
    <div id="hands-on" className="profile-content__section">
      <div className="profile-content__title mb-075">Skills</div>
      <div className="hands-on-experience__chips">
        {experience.map((item) => (
          <CustomChip
            label={item}
            labelClass=""
            onClick={undefined}
            onDelete={undefined}
            variant="outlined"
            color="default"
            size="medium"
            className="hands-on-experience__chip"
          />
        ))}
      </div>
    </div>
  );
}

export default HandsOnExperienceSection;
